import {patchWithAuth} from '@/api'
import {ChangeSettingRequestModel} from '@/stores/payment-methods'
import {PaymentMethodType} from '@/constants'

export const setPaymentMethodSetting = (
    type: Exclude<PaymentMethodType, PaymentMethodType.card>,
    data: ChangeSettingRequestModel
) => patchWithAuth<null>(`/oppapi/v1/${type.toLowerCase()}/settings`, data)
